import React from 'react'
import { Link } from 'react-router-dom'
import BreadCrumb from '../../../components/BreadCrumb'
import { useModal } from '../../../contexts/ModalContext';

export default function IntegrationBanner({breadcrumb}) {
    const { openQueryModal } = useModal();
  return (
    <>
      <section className="integration-banner">
        <img src="/assets/images/integration-bg-img.webp" alt="Seamless" className="img-responsive  integration-bg" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
              <div className="content">
                  {breadcrumb && <BreadCrumb data={breadcrumb} />}
                <h1 className="heading">Your Entire <span className="gradient-color">Logistics Ecosystem, </span> <br/>Perfectly Connected</h1>
                {/* <div className="btn-wrapper">
                  <Link className="theme-btn" onClick={openQueryModal}><span>Get Started Today</span></Link>
                </div> */}
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="image">
               <img src="/assets/images/integration-banner.webp" alt="Integration" className="img-responsive"/>
              </div>
            </div> */}
          </div>
        </div>
      </section>

    </>

  )
}
